import {defineStore} from 'pinia'
import {ref, computed} from 'vue'

export const useFavouritesStore = defineStore('favourites', () => {
    const ids = ref<number[]>([])

    const count = computed(() => ids.value.length)

    const isFavourite = (id: number) => ids.value.includes(id)

    function remove(id: number) {
        ids.value = ids.value.filter((x) => x !== id)
    }

    function add(id: number) {
        if (!isFavourite(id)) ids.value.push(id)
    }

    function toggle(id: number) {
        if (isFavourite(id)) {
            remove(id)
        } else {
            add(id)
        }
    }

    function clear() {
        ids.value = []
    }

    return {ids, count, isFavourite, add, remove, toggle, clear}
}, {persist: true})
